import { yupResolver } from "@hookform/resolvers/yup";
import Input from "../../components/Input/Input";
import { SIGNIN } from "../../data/Sign";

import styles from "../../shared-styles/Sign.module.css";
import { useForm } from "react-hook-form";
import { NavLink, useNavigate } from "react-router";

import schema from "../../utils/validations/SignIn/index";
import Button from "../../components/Button/Button";
import { FunctionComponent } from "react";
import { IconBaseProps } from "react-icons";
import { FaGoogle } from "react-icons/fa";

import { InputNameSignIn, InputTypeSignIn } from "../../types/index";
import { toast } from "react-toastify";

import { useDispatch, useSelector } from "react-redux";
import type { AppDispatch, RootState } from "../../store";

import { signIn as signInDispatch } from "../../store/auth/signInThunk";
import { signInWithGoogle as signInWithGoogleDispatch } from "../../store/auth/Google/signInWithGoogleThunk";
interface FormValues {
  email: string;
  password: string;
}

export default function SignIn() {
  const navigate = useNavigate();

  const dispatch = useDispatch<AppDispatch>();
  const { signInLoading } = useSelector(
    (state: RootState) => state.auth.signIn
  );

  const {
    register,
    handleSubmit,
    formState: { errors, isLoading, isSubmitting }
  } = useForm({
    resolver: yupResolver(schema)
  });

  async function onSubmit(data: FormValues) {
    const resultAction = await dispatch(
      signInDispatch({ email: data.email, password: data.password })
    );

    if (signInDispatch.rejected.match(resultAction)) {
      toast.error(resultAction.payload?.message || "Something went wrong");
    } else {
      toast.success("Sign in successful");
      const cleanTime = setTimeout(() => {
        clearTimeout(cleanTime);
        navigate("/");
      }, 2000);
    }
  }

  async function handleGoogleSignIn() {
    const resultAction = await dispatch(signInWithGoogleDispatch());

    if (signInWithGoogleDispatch.rejected.match(resultAction)) {
      toast.error(resultAction.payload?.message || "Something went wrong");
    } else {
      toast.success("Google sign in successful");
      const cleanTime = setTimeout(() => {
        clearTimeout(cleanTime);
        navigate("/");
      }, 500);
    }
  }

  return (
    <main className={styles.main}>
      <form onSubmit={handleSubmit(onSubmit)} className={styles.form}>
        <h1>Sign In</h1>
        <div className={styles.box}>
          {SIGNIN.map((input) => (
            <Input<InputNameSignIn, InputTypeSignIn>
              key={input.name}
              {...input}
              {...register(input.name)}
              errorMessage={errors[input.name]?.message}
            />
          ))}
          <p className={styles.forgetpass}>
            <NavLink to="/forget-password">ForgetPassword ?</NavLink>
          </p>
          <div className={styles.buttonsActions}>
            <Button
              type="submit"
              className="primary"
              disabled={isLoading || isSubmitting || signInLoading}
            >
              {isLoading || isSubmitting || signInLoading
                ? "Sign In..."
                : "Sign In"}
            </Button>

            <Button
              type="button"
              className="google"
              disabled={isLoading || isSubmitting || signInLoading}
              icon={FaGoogle as FunctionComponent<IconBaseProps>}
              onClick={handleGoogleSignIn}
            >
              {isLoading || isSubmitting || signInLoading
                ? "Sign In..."
                : "Sign In with Google"}
            </Button>

            <p className={styles.navigation}>
              Don't have an account? <NavLink to="/sign-up">SignUp</NavLink>
            </p>
          </div>
        </div>
      </form>
    </main>
  );
}
